import React, { useEffect, useState } from 'react'
import general from '../../general'
import Dialog from '../../lib/Dialog'
import {NavLink} from '../../lib/Navigation'
import { useLocalStorageState } from 'ahooks'

export default function Community() {

  const [data, setData] = useState([])
  const [item, setItem] = useLocalStorageState('chat-community-item',{})

  const getGatherGameList = () => {
    general.axios.post('/base/yunxin/getGatherGameList')
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setData(data)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    getGatherGameList()
  }, [])

  return (
    <div className='community-index'>
      {data?.map((item, index) => {
        return (
          <div className='item' key={index}>
            <div className="header">{item.title}</div>
            <div className="games">
              {item?.items?.map((obj,index) => {
                return (
                  <NavLink onClick={()=>{
                    setItem(obj)
                  }} key={`${index}-${obj.game_id}`} user={false} to={'/chatcommunityDetail?id=' + obj.maiyou_gameid} className='item'>
                    <div className="icon">
                      <img src={obj.game_image.thumb} alt="" />
                    </div>
                    <div className="content">
                      <div className="name">{obj.game_name}</div>
                      <div className="type">{obj.launch_have_watched_type.trim()}</div>
                    </div>
                  </NavLink>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
